<template>
    <content-link-create :client-id="null" :back-route="{ name: 'system-content-links' }" />
</template>
<script>
import ContentLinkCreate from '../../common/content/link/content-link-create.vue'

export default {
    name: 'system-content-links-create',
    components: { ContentLinkCreate }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/content/links/create.vue